/**
* Call to Action JS
* -----------------------------------------------------------------------------
*
* All the JS for the Call to Action component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'call-to-action',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );
      $( '.call-to-action' ).each( function( key, val ) {
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top top',
            end: 'bottom top',
            scrub: 0,
            // markers: true,
          },
        } );

        $( this ).find( '.fit-image img' ).each( function( key, image ) {
          tl.to( image, {y: '10%', ease: 'linear'}, 0 );
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'call-to-action', COMPONENT );
} )( app );
